import React, { Component, Fragment } from 'react'
import moment from 'moment'
import locale from 'antd/lib/date-picker/locale/it_IT'
import { DatePicker, Input, Radio } from 'antd'
import FormItem from 'Components/FormItem'
import SupplierSelect from 'Components/SupplierSelect'
import StoreSelect from 'Components/StoreSelect'
import * as _ from 'lodash'

import {
  agreementPurpose,
  agreementRedeliveryOrganization,
  agreementTransportCosts,
  agreementType,
  userType
} from 'Common/constants'
import { renderRadios } from 'Common/utils'
import { setStores, setSuppliers } from '../../redux-store/actions/data-actions'
import { connect } from 'react-redux'
import { getMainStoreFromUser } from '../../common/utils'

const RangePicker = DatePicker.RangePicker;

class AgreementForm extends Component {
  state = {
    destinationSupplierData: null,
    counterNotes: 0,
    counterSupplierNotes: 0
  };


  constructor(props, context) {
    super(props, context)
    this.destinationSupplierSearchDataUpdate = this.destinationSupplierSearchDataUpdate.bind(this);
  }

  componentWillMount() {
    if (this.props.isProposal) {
      this.saveSelectedSores([getMainStoreFromUser(this.props.user)]);
    }
  }

  componentDidMount() {
    const { data } = this.props;

    if (data.origSupplierId) {
      this.props.showReferences(data.origSupplierId);
    }
  }


  componentDidUpdate(prevProps, prevState, snapshot) {
    if (_.get(prevProps, ['data', 'origSupplierId'], null) !== _.get(this.props, ['data', 'origSupplierId'], null)) {
      this.props.showReferences(this.props.data.origSupplierId);
    }

    if (prevProps.isProposal !== this.props.isProposal) {
      this.saveSelectedSores([getMainStoreFromUser(this.props.user)]);
    }
  }

  saveSelectedSores = stores => {
    let selectedStores = [];

    if (!_.isArray(stores)) {
      return;
    }

    if (stores.includes(0)) {
      selectedStores = [0];
    } else {
      selectedStores = stores;
    }
    // const all = stores.find(el => el.includes(0))
    // // If selected store is "Tutti i negozi", cancel all others
    // if (all && stores.includes(all)) {
    //   newStores = [JSON.parse(all)]
    // } else {
    //   newStores = stores.map(e => JSON.parse(e))
    // }
    // // If selected stores array is empty pass undefined
    // newStores = newStores.length > 0 ? newStores : undefined
    // // Save selected stores on Redux (in the parent component)
    // this.props.onChangeCallback({ agreementStores: newStores })

    _.invoke(this.props, 'onChangeSelectedStores', selectedStores);
  }

  onChangeSupplier = (value) => {
    this.props.onChangeCallback(value)
    this.props.showReferences(value.origSupplierId)
  }

  destinationSupplierSearchDataUpdate = (data) => {
    if (_.get(this.props, 'data.type', null) !== 'SAME_SUPPLIER') {
      return;
    }

    this.setState({destinationSupplierData: data});
  };

  render() {
    const { data, stores, onChangeCallback, user, suppliers } = this.props

    return (
      <Fragment>
        {(user.type === userType.PM.key || (user.type === userType.AM.key && this.props.isProposal === true)) && (
          <Fragment>
            <FormItem label={this.props.isProposal ? "Titolo della proposta" : "Titolo dell'accordo"} key={data.title}>
              <Input
                placeholder={this.props.isProposal ? "Inserisci il titolo della proposta" : "Inserisci il titolo dell'accordo"}
                defaultValue={data.title}
                onBlur={e => onChangeCallback({ title: e.target.value })}
                //onChange={e => onChangeCallback({ title: e.target.value })}
              />
            </FormItem>
            <FormItem label={this.props.isProposal ? "Scopo della proposta" : "Scopo dell'accordo"} key={data.agreementPurpose}>
              <Radio.Group
                defaultValue={data.agreementPurpose ? data.agreementPurpose : Object.keys(agreementPurpose)[0]}
                onChange={e =>
                  onChangeCallback({ agreementPurpose: e.target.value })
                }>
                {renderRadios(agreementPurpose)}
              </Radio.Group>
            </FormItem>
            <FormItem label={this.props.isProposal ? "Tipo di proposta" : "Tipo di accordo"} key={data.type}>
              <Radio.Group
                defaultValue={data.type ? data.type : Object.keys(agreementType)[0]}
                disabled={this.props.isNewAgreement ? this.props.disableSelectSuppliers: true}
                onChange={e => onChangeCallback({ type: e.target.value })}>
                {renderRadios(agreementType)}
              </Radio.Group>
            </FormItem>
            <FormItem label="Fornitore di partenza">
              <SupplierSelect
                // If same supplier is selected, select only destination supplier (origin supplier is disabled)
                disabled={data.type === 'DIFFERENT_SUPPLIER' ? this.props.isNewAgreement ? this.props.disableSelectSuppliers: true : true}
                value={
                  data.type === 'SAME_SUPPLIER'
                    ? data.destSupplierId
                    : data.origSupplierId
                }
                suppliers={suppliers}
                syncData={this.state.destinationSupplierData}
                defaultValue={data.origSupplierId}
                onChange={value => this.onChangeSupplier({ origSupplierId: value })}
              />
            </FormItem>
            <FormItem label="Fornitore di destinazione">
              <SupplierSelect
                value={data.destSupplierId}
                searchDataUpdate={(data) => {this.destinationSupplierSearchDataUpdate(data)}}
                disabled={this.props.isNewAgreement ? this.props.disableSelectSuppliers: true}
                defaultValue={data.destSupplierId}
                suppliers={suppliers}
                // If same supplier is selected, origin supplier and destination supplier are the same
                onChange={value =>
                  data.type !== 'DIFFERENT_SUPPLIER'
                    ?
                    this.onChangeSupplier({
                      destSupplierId: value,
                      origSupplierId: value
                    })
                    : onChangeCallback({ destSupplierId: value })
                }
              />
            </FormItem>
            <FormItem label="Date di validità" key={data.validFrom + ' ' + data.validTo}>
              <RangePicker
                showTime={false}
                locale={locale}
                format="DD-MM-YYYY"
                onChange={value =>
                  onChangeCallback({
                    validFrom: value && value.length ? value[0].toISOString() : undefined,
                    validTo: value && value.length ? value[1].toISOString() : undefined
                  })
                }
                defaultValue={
                  !_.isNil(data.validFrom) && !_.isNil(data.validTo)
                    ? [moment(data.validFrom), moment(data.validTo)]
                    : null
                }
              />
            </FormItem>
            {!this.props.isProposal && <FormItem label="Negozi">
              <StoreSelect
                data={data}
                stores={stores}
                value={this.props.selectedStores}
                disabled={this.props.disableSelectStore}
                onChange={value => this.saveSelectedSores(value)}
              />
            </FormItem>}
          </Fragment>
        )}
        <FormItem label="Organizzazione ritiro" key={data.redeliveryOrganization}>
          <Radio.Group
            defaultValue={Object.keys(agreementRedeliveryOrganization)[0]}
            value={data.redeliveryOrganization}
            onChange={e =>
              onChangeCallback({
                redeliveryOrganization: e.target.value,
                transportCosts: 'SUPPLIER'
              })
            }>
            {renderRadios(agreementRedeliveryOrganization)}
          </Radio.Group>
        </FormItem>
        {/* Show transportCost radios only if redeliveryOrganization is equal to SEND_TO_SUPPLIER */}
        {data.redeliveryOrganization === 'SEND_TO_SUPPLIER' && (
          <FormItem label="Costi di trasporto">
            <Radio.Group
              defaultValue={data.transportCosts}
              onChange={e =>
                onChangeCallback({ transportCosts: e.target.value })
              }>
              {renderRadios(agreementTransportCosts)}
            </Radio.Group>
          </FormItem>
        )}
        {/* Shows notes field based on user type */}
        {(user.type === userType.PM.key || (user.type === userType.AM.key && this.props.isProposal === true)) && (
          <FormItem label="Note">
            <Input.TextArea
              placeholder="Scrivi una nota"
              maxLength={255}
              autosize={{ minRows: 2, maxRows: 6 }}
              defaultValue={data.notes}
              // value={data.notes}
              onChange={e => {onChangeCallback({notes: e.target.value}); this.setState({counterNotes: e.target.value.length})}}
            />
            <span>{this.state.counterNotes}/255 caratteri</span>
          </FormItem>
        )}
        {user.type === userType.S.key && (
          <FormItem label="Sede logistica di consegna">
            <Input.TextArea
              maxLength={255}
              placeholder="Indica la sede logistica per la consegna del reso"
              autosize={{ minRows: 3, maxRows: 6 }}
              defaultValue={data.supplierNotes}
              // value={data.supplierNotes}
              onChange={e => {onChangeCallback({ supplierNotes: e.target.value }); this.setState({counterSupplierNotes: e.target.value.length})}}
            />
            <span>{this.state.counterSupplierNotes}/255 caratteri</span>
          </FormItem>
        )}
      </Fragment>
    )
  }
}

export default connect(state => {
  return {
    stores: state.Data.stores,
    suppliers: state.Data.suppliers
  }
}, {
  setSuppliers,
  setStores
})(AgreementForm);



// WEBPACK FOOTER //
// ./src/components/AgreementForm/index.js